function Cache() {
  // 存储数据的对象
  this.data = {};

  // 通过 key 获取 value
  this.get = function (key) {
    const record = this.data[key];
    if (!record) {
      return null;
    }

    // 判断是否过期，过期的数据将被删除
    if (record.expirationTime && record.expirationTime < Date.now()) {
      delete this.data[key];
      return null;
    }

    return record.value;
  };

  // 通过 key 设置 value，可以设置有效期
  this.set = function (key, value, expirationTime) {
    this.data[key] = {
      value,
      expirationTime: expirationTime ? Date.now() + expirationTime : null // 计算过期时间
    };
  };

  // 从 Cache 中删除一组数据
  this.delete = function (key) {
    delete this.data[key];
  };

  // 清空 Cache 中的所有数据
  this.clear = function () {
    this.data = {};
  };
}

let cache = new Cache();

module.exports = { cache, Cache };
